import { revokeAuth } from '~/actions/user.actions';
import { AxiosInstance } from 'axios';
import { Middleware } from 'redux';

function authRevokeMiddleware(clients: AxiosInstance[]): Middleware {
  return (store) => {
    clients.forEach((client) => {
      client.interceptors.response.use(
        (response) => response,
        (error) => {
          if (error?.response?.status === 401) {
            store.dispatch(revokeAuth());
          }
          return Promise.reject(error);
        },
      );
    });

    return (next) => (action) => next(action);
  };
}

export default authRevokeMiddleware;
